/**
 * API関係の設定値定義
 */

// QRコード周りの設定
export class QrCodeSetting {
  static readonly PARAM_SEPARATOR = '|'
}

// 問題PDFダウンロード周りの設定
export class ProblemsPdfSetting {
  static readonly PROBLEM = 'problem'
  static readonly EXPLANATION = 'explanation'
}

// 小項目のカテゴリー設定
export class SUnitCategorySetting {
  /** 直前チェック */
  static readonly LAST_MINUTE_CHECK = 1
  /** 解き直し */
  static readonly RESOLVE = 2
}

// テストコンテンツ周りの設定
export class StudyContentSetting {
  /** デフォルト機能種別 */
  static readonly DEFAULT_FUNCTION_TYPE = 'CBT'
  /** デフォルト学習モード */
  static readonly DEFAULT_STUDY_MODE = 'TJ'
}
